import { Button, SwitchButton } from "@ui";
import style from "./AutoRenewal.module.scss";

export function AutoRenewal() {
    return (
        <div className={style.container}>
            <div className="flex justify-between items-center mb-[13px]">
                <p className={style.label}>Автопродовження тарифу</p>
                <SwitchButton 
                    checked
                    onChecked={() => {}}
                    size="big"
                />
            </div>
            <p className={style.description}>
                Вибрані тарифи <span>автоматично будуть продовжуватись</span>, за умови, якщо на вашому балансі буде достатньо коштів.
            </p>
            <Button 
                text="Зберегти"
                color="blue"
                customStyle={{
                    button: "!px-[60px] !py-[11px] !ml-auto"
                }}
            />
        </div>
    )
}